module.exports = __webpack_public_path__ + "media/landing/panelak-872c26cd.jpg";